"use strict";

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

function splitProps(props, keys) {
  var matchedProps = {};
  var remainingProps = {};
  var propKeys = Object.keys(props);

  for (var i = 0; i < propKeys.length; i++) {
    var propKey = propKeys[i];
    var propValue = props[propKey];

    if (keys.includes(propKey)) {
      matchedProps[propKey] = propValue;
    } else {
      remainingProps[propKey] = propValue;
    }
  }

  return {
    matchedProps: matchedProps,
    remainingProps: remainingProps
  };
}

exports["default"] = splitProps;